import { Field } from 'react-final-form';
import { useTranslation } from '../../../../utils/useTranslation';
import { WithHint } from '../../../feedback/Tooltip';
import { FormControl } from '../../../input/FormControl';
import { Input } from '../../../input/Input';
import { Typography } from '../../../typography/Typography';
import { BusinessType } from '../../types';
import { textDictionary, validateDisplayName, validateDomain, validateUrl } from '../constants';
import { LinkField } from './LinkField';
import { SocialLinkFields } from './SocialLinkFields';

export const BusinessFields = ({
    onFieldBlur,
}: {
    onFieldBlur: (name: string, value: string) => void;
}) => {
    const t = useTranslation();
    const textMap = textDictionary[BusinessType.BUSINESS];

    return (
        <>
            <Typography variant="title2" weight="bold" py={2}>
                {t('Зарегистрироваться в Яндекс Ритме')}
            </Typography>
            <Typography variant="body">{t(textMap.registerDisclaimer)}</Typography>

            <Typography variant="body" pt={1}>
                {t('Одному логину может принадлежать один бизнес.')}
            </Typography>
            <Field
                name="domain"
                validate={validateDomain}
                render={({ input, meta }) => (
                    <FormControl
                        pt={2.5}
                        pb={1}
                        label={t('Укажите сайт')}
                        required
                        error={meta.touched ? Boolean(meta.error) : undefined}
                        message={meta.touched ? meta.error : undefined}
                    >
                        <Input
                            {...input}
                            type="text"
                            autoComplete="off"
                            placeholder="https://"
                            onBlur={(event) => {
                                onFieldBlur('domain', event.target.value);
                                input.onBlur(event);
                            }}
                        />
                    </FormControl>
                )}
            />

            <Typography variant="title3" weight="bold" py={2}>
                <WithHint message={t(textMap.socialLinksHint)}>{t(textMap.socialLinks)}</WithHint>
            </Typography>
            <SocialLinkFields businessType={BusinessType.BUSINESS} onFieldBlur={onFieldBlur} />

            <LinkField
                name="otherUrl"
                validate={validateUrl}
                label={t('Ссылка на ваш профиль на любом другом ресурсе')}
                placeholder="https://"
                onFieldBlur={onFieldBlur}
            />
            <Typography variant="title3" weight="bold" py={2}>
                {t('Информация о бизнесе')}
            </Typography>
            <Field
                name="displayName"
                validate={validateDisplayName}
                render={({ input, meta }) => (
                    <FormControl
                        py={1}
                        required
                        label={t('Название бизнеса')}
                        error={meta.touched ? Boolean(meta.error) : undefined}
                        message={meta.touched ? meta.error : undefined}
                    >
                        <Input
                            {...input}
                            type="text"
                            autoComplete="off"
                            placeholder={t('Не заполнено')}
                            onBlur={(event) => {
                                onFieldBlur('displayName', event.target.value);
                                input.onBlur(event);
                            }}
                        />
                    </FormControl>
                )}
            />
            <LinkField
                name="email"
                required
                disabled
                label={t('Адрес электронной почты')}
                placeholder="Не заполнено"
                onFieldBlur={onFieldBlur}
            />
            <Typography variant="caption" color="secondary">
                {t('На вашу почту мы будем присылать важные уведомления от сервиса')}
            </Typography>
        </>
    );
};
